import { POST } from '@/utils/axios'

export const getProfileChartData = async formData =>
  await POST('/profile-chart', formData)

export const getTetradCompletionQuestionData = async formData =>
  await POST('/get-tetrad-completion-screen', formData)

export const submitAnswer = async formData => await POST('/next-step', formData)
